export default function (state, val) {
    for (let k in val) {
        state.form[k] = val[k];
    }
}